import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Animated, TouchableHighlight, View } from 'react-native';
import LightboxOverlay from './LightboxOverlay';

var Lightbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Lightbox, _Component);

  function Lightbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Lightbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Lightbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      origin: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      layoutOpacity: new Animated.Value(1)
    });

    _defineProperty(_assertThisInitialized(_this), "getContent", function () {
      if (_this.props.renderContent) {
        return _this.props.renderContent();
      } else if (_this.props.activeProps) {
        return cloneElement(Children.only(_this.props.children), _this.props.activeProps);
      }

      return _this.props.children;
    });

    _defineProperty(_assertThisInitialized(_this), "getOverlayProps", function () {
      return {
        isOpen: _this.state.isOpen,
        origin: _this.state.origin,
        renderHeader: _this.props.renderHeader,
        swipeToDismiss: _this.props.swipeToDismiss,
        springConfig: _this.props.springConfig,
        backgroundColor: _this.props.backgroundColor,
        children: _this.getContent(),
        onClose: _this.onClose
      };
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this._root.measure(function (ox, oy, width, height, px, py) {
        _this.props.onOpen();

        _this.setState({
          isOpen: _this.props.navigator ? true : false,
          isAnimating: true,
          origin: {
            width: width,
            height: height,
            x: px,
            y: py
          }
        }, function () {
          if (_this.props.navigator) {
            var route = {
              component: LightboxOverlay,
              passProps: _this.getOverlayProps()
            };

            var routes = _this.props.navigator.getCurrentRoutes();

            routes.push(route);

            _this.props.navigator.immediatelyResetRouteStack(routes);
          } else {
            _this.setState({
              isOpen: true
            });
          }

          setTimeout(function () {
            _this._root && _this.state.layoutOpacity.setValue(0);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      throw new Error('Lightbox.close method is deprecated. Use renderHeader(close) prop instead.');
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.state.layoutOpacity.setValue(1);

      _this.setState({
        isOpen: false
      }, _this.props.onClose);

      if (_this.props.navigator) {
        var routes = _this.props.navigator.getCurrentRoutes();

        routes.pop();

        _this.props.navigator.immediatelyResetRouteStack(routes);
      }
    });

    return _this;
  }

  _createClass(Lightbox, [{
    key: "render",
    value: function render() {
      var _this2 = this; // measure will not return anything useful if we dont attach a onLayout handler on android


      return React.createElement(View, {
        ref: function ref(component) {
          return _this2._root = component;
        },
        style: this.props.style,
        onLayout: function onLayout() {}
      }, React.createElement(Animated.View, {
        style: {
          opacity: this.state.layoutOpacity
        }
      }, React.createElement(TouchableHighlight, {
        underlayColor: this.props.underlayColor,
        onPress: this.open
      }, this.props.children)), this.props.navigator ? false : React.createElement(LightboxOverlay, this.getOverlayProps()));
    }
  }]);

  return Lightbox;
}(Component);

_defineProperty(Lightbox, "propTypes", {
  activeProps: PropTypes.object,
  renderHeader: PropTypes.func,
  renderContent: PropTypes.func,
  underlayColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  springConfig: PropTypes.shape({
    tension: PropTypes.number,
    friction: PropTypes.number
  }),
  swipeToDismiss: PropTypes.bool
});

_defineProperty(Lightbox, "defaultProps", {
  swipeToDismiss: true,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
});

export { Lightbox as default };